export const DEFAULT_PRODUCT_WEIGHT = 100;
